export const HolidayType = {
  NATIONAL: "national",
  RELIGIOUS: "religious",
  COMPANY: "company",
  REGIONAL: "regional"
} as const;

export const HolidayApplicableGender = {
  ALL: 0,
  MALE: 1,
  FEMALE: 2,
  OTHER: 3
} as const;

export const HolidayApplicableReligion = {
  ALL: "all",
  HINDUISM: "hinduism",
  ISLAM: "islam",
  CHRISTIANITY: "christianity",
  BUDDHISM: "buddhism",
  OTHER: "other"
} as const;
